import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/SearchInterfacesInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/searchinterfaces`;
	}
	listSearchInterfacesByProjectId(e, t = {}) {
		return this.api.get(this.buildPath(`${n.baseUrl}/projects/interfaces`, {
			...t,
			projectId: e
		}));
	}
};
export { n as SearchInterfacesInternalResource };

//# sourceMappingURL=SearchInterfacesInternalResource.js.map